import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';
import { ENDPOINT_TABS, type EndpointTab } from '@/features/admin/shared/tabs';
import { EndpointDetailPage } from '@/features/admin/endpoints/endpoint-pages';
import { ConsoleShell } from '@/features/shell/console-shell';

/** Détail d'un endpoint de serving (porting README #54). L'onglet actif vit dans l'URL (`?tab=`). */
export const Route = createFileRoute('/$tenant/projects/$projectId/endpoints/$endpointId')({
  validateSearch: (search: Record<string, unknown>): { tab: EndpointTab } => ({
    tab: ENDPOINT_TABS.parse(search['tab']),
  }),
  component: EndpointRoute,
});

function EndpointRoute() {
  const { tenant, projectId, endpointId } = Route.useParams();
  const { tab } = Route.useSearch();
  const navigate = useNavigate({ from: Route.fullPath });
  const { t } = useTranslation();
  return (
    <ConsoleShell
      tenantId={tenant}
      projectId={projectId}
      activeItem="endpoints"
      crumbs={[{ label: t('nav.items.endpoints') }, { label: endpointId, mono: true }]}
    >
      <EndpointDetailPage
        tenantId={tenant}
        projectId={projectId}
        endpointId={endpointId}
        tab={tab}
        onTabChange={(next) => void navigate({ search: { tab: next }, replace: true })}
      />
    </ConsoleShell>
  );
}
